import { GameState } from "./GameState";
import { LaunchState } from "./LaunchState";
import { MissionsPopup } from "./MissionsPopup";

export type CharacterUnlockData = {
	name: string;
	unlockString: string;
	button: string;
	color: string;
	imageOffset: { x: number, y: number };
	slingSeatOffset: {x: number, y: number}
	slamOrigin: { x: number, y: number };
	dizzyOffset: { x: number, y: number };
	crashOffset: { x: number, y: number };
	slideOffset: number;
	missionsToComplete: number;
	scale?: number;
}

export class MissionsState extends GameState {

	start(): void {
		this.scene.pausePhaserSystems();

		const recap = new MissionsPopup(this.scene, this.scene.transitionedIntoScene ? 600 : 0);
		this.scene.uiContainer.add(recap);
		this.scene.addResize(() => {
			this.scene.alignIn.Center(recap, this.scene.viewport);
		});
		recap.once(MissionsPopup.ON_CLOSED, this.next, this);

	}

	next(): void {
		this.game.switchState(new LaunchState(this.game, this.scene));
	}

}